import React from 'react'

import { ButtonClean, Fieldset } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
}

export const AddAnotherRule = ({ form }: Props) => (
  <Fieldset.Row inner>
    <ButtonClean
      label="Add another rule"
      withUnderline
      onClick={() => {
        form.setFieldValue(
          FormFields.rules,
          form.values.rules.concat({
            type: 'EmptyRule',
          }),
        )
      }}
    />
  </Fieldset.Row>
)
